import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { DividerComponent, LoaderComponent, NotificationModule, PageComponent } from '@ftr/foundation'
import { CourtroomDisplayComponent } from '~app/features/courtroom-display/courtroom-display.component'
import { FtrFormsModule } from '~app/shared/ftr-forms.module'

@NgModule({
  imports: [RouterModule, DividerComponent, PageComponent, LoaderComponent, NotificationModule, FtrFormsModule],
  declarations: [CourtroomDisplayComponent],
  exports: [CourtroomDisplayComponent],
})
export class CourtroomDisplayModule {}
